<template>
  <div class="wrapper">
    <div class="section section-contactus-1 section-image" :style="headerStyle">
      <div class="container" style="margin-top: 50px">
        <div class="md-layout md-input">
          <div class="md-layout-item md-size-40 md-small-size-100">
            <h2 class="title">Get in Touch</h2>
            <h5 class="description">
              You need more information? Check what other persons are saying
              about our work. They are very happy with their new spaces. 
            </h5>
            <div class="info info-horizontal">
              <div class="icon icon-danger">
                <i class="md-icon md-icon-font md-theme-default">email</i>
              </div>
              <div class="description">
                <h4 class="info-title">Send us an email</h4>
                <div class="description">
                  <p>hola.globalvision@gmail.com</p>
                </div>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-danger">
                <i class="md-icon md-icon-font md-theme-default">phone</i>
              </div>
              <div class="description">
                <h4 class="info-title">Give us a ring</h4>
                <div class="description">
                  <p>
                    <br />
                    +1 (416) 723-6126 <br />
                    Mon - Fri, 8:00-22:00
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-40 md-small-size-100 ml-auto">
            <form class="contact-form" @submit.prevent="sendEmail">
              <div class="md-card md-card-contact md-theme-default">
                <div class="md-card-header md-card-header-danger text-center">
                  <h4 class="card-title">Contact Us</h4>
                </div>
                <div class="md-card-content">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-small-size-100">
                      <md-field class="md-field md-theme-default">
                        <label for="md-input-gpm0uazd">Name</label
                        ><md-input
                          type="text"
                          id="md-input-gpm0uazd"
                          class="md-input"
                          v-model="name"
                          required
                        />
                        <!---->
                        <!---->
                        <!---->
                      </md-field>
                    </div>
                  </div>
                  <md-field class="md-field md-theme-default">
                    <label for="md-input-y957omvi">Email Adress</label
                    ><md-input
                      type="email"
                      id="md-input-y957omvi"
                      class="md-input"
                      v-model="email"
                      required
                    />
                    <!---->
                    <!---->
                    <!---->
                  </md-field>
                  <md-field class="md-field md-theme-default md-has-textarea">
                    <label for="md-textarea-row9dp3xt">Your Message</label
                    ><md-textarea
                      id="md-textarea-row9dp3xt"
                      class="md-textarea"
                      v-model="message"
                      required
                    ></md-textarea>
                    <!---->
                    <!---->
                    <!---->
                  </md-field>
                </div>
                <div class="md-card-actions text-center" style="border-top: none !important; border-bottom: none !important">
                  <button
                    type="submit"
                    class="md-button md-danger md-theme-default "
                  >
                    <div class="md-ripple">
                      <div class="md-button-content"><span :class="ActiveSpinner? ' hidden':'show'">Send Message</span>
                       <div class="spinner" :class="ActiveSpinner? ' show':'hidden'"></div></div>
                    </div>
                  </button>
                </div>
                
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
export default {
  data() {
    return {
      ActiveSpinner: false,
      classicModal: false,
      name: null,
      email: null,
      message: null,
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundColor: "black",
      };
    },
  },
  methods: {
    sendEmail() {
      this.ActiveSpinner = true;
      emailjs.send(
        process.env.VUE_APP_YOUR_SERVICE_ID,
        process.env.VUE_APP_YOUR_TEMPLATE_ID,
        {
          name: this.name,
          email: this.email,
          message: this.message,
        },
        process.env.VUE_APP_YOUR_USER_ID
      );
      setTimeout(() => {
        this.ActiveSpinner = false;
      }, 1000);
      // Reset form field
      this.name = "";
      this.email = "";
      this.message = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}

.spinner {
  border: 4px solid white;
  border-left-color: transparent;
 border-radius: 50%;
 width:10px;
 height:10px;
  
  animation: spin 1s linear infinite;
}
.hidden{
  display: none !important;
}
.show{
  display: block !important;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>